import { connect } from 'react-redux'
import { googleAnalyticsEvent } from 'Modules/googleAnalytics/actions'
import FilterBar from './FilterBar'

export default connect(state => ({
  isMobileApp: state.app.isMobileApp,
  isMobile: state.app.isMobile,
}), {
  googleAnalyticsEvent,
})(FilterBar)
